import { API_HOST } from '@pm/core';
import { FlowEventPayload } from '@pm/forms';
import * as Sentry from '@sentry/react';
import { matchPath } from 'react-router';
import { embeddedFormRoutes } from '../modules/embedded-form/embedded-form-routes';

export const awaitsUsableForm = (pathname: string) =>
  Boolean(
    matchPath(embeddedFormRoutes.flowOnlyInauth.path, pathname) ??
    matchPath(embeddedFormRoutes.flowAndVariantInauth.path, pathname),
  );

export const describeIntakePageload = () => {
  const campaignSource = new URLSearchParams(window.location.search).get(
    'utm_source',
  );

  Sentry.getActiveSpan()?.setAttributes({
    'intake.route': window.location.pathname,
    ...(campaignSource && { 'intake.utm_source': campaignSource }),
  });
};

export const markIntakeFormMounted = () => {
  performance.mark('intake-form-mounted');
};

export const reportFormUsable = ({ variantRevisionUuid }: FlowEventPayload) => {
  if (variantRevisionUuid) {
    Sentry.getActiveSpan()?.setAttribute(
      'intake.variant_revision_uuid',
      String(variantRevisionUuid),
    );
  }

  Sentry.getCurrentScope().setTag('intake.form_usable', true);

  Sentry.reportPageLoaded();
};

type IntakeFormLoaded = {
  flowLabel: string;
  variantRevisionUuid?: string | null;
  anonymousId?: string | null;
  countryCode?: string | null;
};

export const sendIntakeFormLoaded = ({
  flowLabel,
  variantRevisionUuid,
  anonymousId,
  countryCode,
}: IntakeFormLoaded) => {
  const fields = Object.entries({
    flow_label: flowLabel,
    variant_revision_uuid: variantRevisionUuid,
    anonymous_id: anonymousId,
    country_code: countryCode,
  }).filter((field): field is [string, string] => Boolean(field[1]));

  navigator.sendBeacon?.(
    `${API_HOST}/intake_events/form_loaded`,
    new URLSearchParams(fields),
  );
};
